import {computed, decorate, observable} from 'mobx';
import {max, min, sum} from 'lodash';
import {BaseModel} from './base';
import {Operation} from './operation';

export class AggregatedOperation extends BaseModel {
  constructor(operations, parent, parentOrderId) {
    super();

    this.id = `order${parentOrderId}`;
    this.children = operations;
    this.parent = parent;
    this.parentOrderId = parentOrderId;
    this.sortOrder = operations[0].sortOrder;
    this.tmpSortOrder = operations[0].sortOrder;
  }

  get order() {
    return this.parent;
  }

  get plannedStart() {
    return min(this.children.map((op) => op.plannedStart));
  }

  get plannedEnd() {
    return min(this.children.map((op) => op.plannedStart));
  }

  get actualStart() {
    return min(this.children.map((op) => op.actualStart));
  }

  get actualEnd() {
    return max(this.children.map((op) => op.actualStart));
  }

  get plannedDurationSeconds() {
    return sum(this.children.map((op) => op.plannedDurationSeconds));
  }

  get displayStatus() {
    if (this.children.some((op) => op.displayStatus === Operation.displayStates.active)) {
      return Operation.displayStates.active;
    }
    if (this.children.every((op) => op.displayStatus === Operation.displayStates.disabled)) {
      return Operation.displayStates.disabled;
    }
    if (this.children.some((op) => op.displayStatus === Operation.displayStates.paused)) {
      return Operation.displayStates.paused;
    }
    if (this.children.some((op) => op.displayStatus === Operation.displayStates.planned)) {
      return Operation.displayStates.planned;
    }

    return Operation.displayStates.finished;
  }

  get isActive() {
    return this.displayStatus === Operation.displayStates.active;
  }

  get isPaused() {
    return this.displayStatus === Operation.displayStates.paused;
  }

  get isPlanned() {
    return this.displayStatus === Operation.displayStates.planned;
  }

  get isFinished() {
    return this.displayStatus === Operation.displayStates.finished;
  }
}

decorate(AggregatedOperation, {
  id: observable,
  children: observable,
  order: computed,
  plannedStart: computed,
  plannedEnd: computed,
  actualStart: computed,
  actualEnd: computed,
  plannedDurationSeconds: computed,
  displayStatus: computed,
  isActive: computed,
  isPlanned: computed,
  isFinished: computed,
});
